'use strict';

function isLight(color) {
  var c = color.substring(1);
  var rgb = parseInt(c, 16);
  var r = (rgb >> 16) & 0xff;
  var g = (rgb >> 8) & 0xff;
  var b = (rgb >> 0) & 0xff;
  return (r * 0.299 + g * 0.587 + b * 0.114) > 128;
}

exports.isLight = isLight;

exports.getTopBarBackgroundColor = function (color) {
  if (isLight(color)) {
    return 'rgba(0, 0, 0, 0.2)';
  }
  return 'rgba(255, 255, 255, 0.2)';
};

/**
 * 获取颜色的RGBA值
 * @author mengxiaojiang
 * @createDate 2016-7-4
 * @param color {String('#XXX'|'#XXXXXX'|'rgba(r,g,b,a))}
 * @returns {{R: number, G: number, B: number, A : number}}
 */
exports.getRGBA = function (color) {
  var r = 0;
  var g = 0;
  var b = 0;
  var a = 1;
  var c;
  var l;
  if (color) {
    if (color.indexOf('rgba') != -1) {
      c = color.replace('rgba', '').replace('(', '').replace(')', '');
      c = c.split(',');
      r = parseInt(c[0].trim(), 10);
      g = parseInt(c[1].trim(), 10);
      b = parseInt(c[2].trim(), 10);
      a = parseInt(c[3].trim(), 10);
    } else if (color.indexOf('#') != -1) {
      c = color.replace('#', '').split('');
      l = c.length;
      if (l <= 3) {
        b = c.pop();
        b = parseInt(b + b, 16);
        l = c.length;
        if (l) {
          g = c.pop();
          g = parseInt(g + g, 16);
        }
        l = c.length;
        if (l) {
          r = c.pop();
          r = parseInt(r + r, 16);
        }
      } else {
        b = c.pop();
        if (c.length) {
          b = c.pop() + b;
        }
        b = parseInt(b, 16);
        if (c.length) {
          g = c.pop();
        }
        if (c.length) {
          g = c.pop() + g;
        }
        if (g) {
          g = parseInt(g, 16);
        }
        if (c.length) {
          r = c.pop();
        }
        if (c.length) {
          r = c.pop() + r;
        }
        if (r) {
          r = parseInt(r, 16);
        }
      }
    }
  }
  return {
    R: r,
    G: g,
    B: b,
    A: a
  };
};



// WEBPACK FOOTER //
// ./src/helper/colorHelper.js